<template>
    <div>
      <div class="search-bar-margin-bottom-cla">
        <el-form
          style="display:flex;margin-top:5px"
          :inline="true"
          :model="params"
          class="demo-form-inline"
        >
          <el-form-item prop="condition">
            <el-input
              clearable
              v-model.trim="params.condition"
              :placeholder="$t('hybird.searchPlaceholder')"
            ></el-input>
          </el-form-item>

          <el-button type="primary" @click="searchFn" icon="el-icon-search">{{
            $t('common.search')
          }}</el-button>
        </el-form>
      </div>

      <div class="black_panel_cla">
        <el-table
          ref="multipleTable"
          :data="tableData"
          style="width: 100%"
          :highlight-current-row="true"
        >
          <el-table-column prop="id" :label="$t('hybird.id')">
          </el-table-column>
          <el-table-column
            prop="userName"
            :label="$t('hybird.userName')"
          >
          </el-table-column>

          <el-table-column
            prop="companyName"
            :label="$t('hybird.companyName')"
          >
          </el-table-column>

          <el-table-column
            prop="companyId"
            :label="$t('hybird.companyId')"
          >
          </el-table-column>

          <el-table-column
            prop="activeCode"
            :label="$t('hybird.activeCode')"
          >
          </el-table-column>

          <el-table-column
            prop="createdTime"
            :label="$t('hybird.createdTime')"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.createdTime | dataFormat }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="status" :label="$t('hybird.status')">
            <template slot-scope="scope">
              <div  style="color: #4db22f"  v-if="scope.row.status ===true">
                  <span class="zk-icon-iconfontzhizuobiaozhun023139"></span><span  style="padding-left:10px">{{$t('hybird.active')}}</span>
              </div>
              <div style="color:red" v-if="scope.row.status === false">
                <span class="zk-icon-jinyong1"></span><span  style="padding-left:10px">{{$t('hybird.unActive')}}</span>
              </div>
            </template>
          </el-table-column>

        </el-table>
        <div style="margin-top:15px">
          <el-pagination
            background
            @size-change="changePageSize"
            @current-change="changePage"
            :current-page="pager.curPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            layout="total, prev, pager, next, sizes, jumper"
          ></el-pagination>
        </div>

      </div>
    </div>
  </template>

<script>
import { findClinetInfoByPage } from '@/services/hybridApi'
export default {
  data() {
    return {
      tableData: [],
      params: {
        condition: ''
      },
      currentRow: {}
    }
  },
  mounted() {
    this.getHistoryList()
  },
  methods: {

    getHistoryList() {
      let params = Object.assign({}, this.params)
      findClinetInfoByPage({
        params: params,
        pager: this.pager
      })
        .then(data => {
          if (data.code) {
            this.tableData = data.payload.results
            this.pager.total = data.payload.totalRecords
            this.pager.pageSize = data.payload.pageSize
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch(e => {
          this.errorMessage(e)
        })
    },

    changePage(current) {
      this.pager.curPage = current
      this.getHistoryList()
    },

    changePageSize(pageSize) {
      this.pager.pageSize = pageSize
      this.getHistoryList()
    },

    searchFn() {
      this.pager.curPage = 1
      this.getHistoryList()
    }

  }
}
</script>

  <style scoped lang="less">
  .history-box {
    background-color: #ffffff;
  }
  .report-box {
    display: flex;
    width: 100%;
    padding: 50px;
    margin-bottom: 60px;
    box-sizing: border-box;
    .report-item {
      position: relative;
      height: 10px;
      background-color: #ebeff5;
    }
    .report-item1 {
      width: 2px;
      .report-item;
    }
    .report-item2,
    .report-item3,
    .report-item4 {
      flex-grow: 1;
      .report-item;
    }
    .circle-box {
      position: absolute;
      right: -10px;
      top: -5px;
      z-index: 1000;
      background: #ffffff;
      height: 20px;
      width: 20px;
      border-radius: 50%;
    }
    .check-icon {
      position: absolute;
      right: 4px;
      top: 4px;
      font-size: 12px;
      font-weight: 600;
    }
    .report-msg-cla {
      position: absolute;
      left: -45px;
      top: 30px;
      width: 90px;
      text-align: center;
    }

    .unactive-cla {
      background-color: #ebeff5;
      .check-icon-cla {
        color: #ebeff5;
      }
    }
    .actvie-cla {
      background-color: #4db22f;
      .check-icon,
      .check-icon-cla {
        color: #4db22f;
      }
    }
    .error-cla {
      background-color: red;
      .check-icon-cla {
        color: red;
      }
    }
    .check-icon-cla {
      font-size: 20px;
    }
  }
  .dia-info-cla {
    display: flex;
    height: 100px;
    justify-content: space-around;
    align-items: center;
  }
  </style>



// WEBPACK FOOTER //
// src/modules/hybird/activeCode.vue